/* eslint-disable @typescript-eslint/no-explicit-any */
import request from "../Utils/request";

export function deleteData(url: string, data?: any) {
  return request.delete(url, data);
}
